import { render } from "./MshelConstruction.vue?vue&type=template&id=70aaa4c8&scoped=true"
import script from "./MshelConstruction.vue?vue&type=script&lang=js"
export * from "./MshelConstruction.vue?vue&type=script&lang=js"

import "./MshelConstruction.vue?vue&type=style&index=0&id=70aaa4c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aaa4c8"]])

export default __exports__